import { __extends } from "tslib";
import { GroupBuilder } from './group.builder';
var GroupWithMembersBuilder = /** @class */ (function (_super) {
    __extends(GroupWithMembersBuilder, _super);
    function GroupWithMembersBuilder() {
        var _this = _super.call(this) || this;
        _this.group.members = [];
        return _this;
    }
    GroupWithMembersBuilder.prototype.withMembers = function (members) {
        this.group.members = members;
        return this;
    };
    GroupWithMembersBuilder.prototype.build = function () {
        return this.group;
    };
    return GroupWithMembersBuilder;
}(GroupBuilder));
export { GroupWithMembersBuilder };
//# sourceMappingURL=group-with-members.builder.js.map